"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchMiddleware = void 0;

require("isomorphic-fetch");

var _buildUrl = require("./build-url");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var defaultFetchConfig = {
  method: 'GET',
  mode: 'cors',
  credentials: 'same-origin',
  headers: {
    'Content-Type': 'application/json'
  },
  referrerPolicy: 'no-referrer'
};

var fetchMiddleware = function fetchMiddleware(api) {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(action) {
        var nextResult, _action$metadata, url, correlationId, _action$config$method, _action$config, _action$config2, response, result, payload, depth, path, _action$metadata2, _url, _correlationId, _action$config$method2, _action$config3, _action$config4, _response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                nextResult = next(action);

                if (!(action.type === 'QUERY')) {
                  _context.next = 41;
                  break;
                }

                url = (0, _buildUrl.buildUrl)(api.getState().config.baseUrl, action.payload.endpoint, action.payload.params);
                correlationId = (_action$metadata = action.metadata) === null || _action$metadata === void 0 ? void 0 : _action$metadata.correlationId;
                _context.prev = 4;
                _context.next = 7;
                return fetch(url, _objectSpread(_objectSpread({}, defaultFetchConfig), {}, {
                  method: (_action$config$method = action === null || action === void 0 ? void 0 : (_action$config = action.config) === null || _action$config === void 0 ? void 0 : _action$config.method) !== null && _action$config$method !== void 0 ? _action$config$method : 'GET',
                  headers: _objectSpread(_objectSpread({}, defaultFetchConfig.headers), {}, {
                    authorization: ((_action$config2 = action.config) === null || _action$config2 === void 0 ? void 0 : _action$config2.authorization) || ''
                  })
                }));

              case 7:
                response = _context.sent;

                if (!(response.status < 200 || response.status >= 400)) {
                  _context.next = 22;
                  break;
                }

                // eslint-disable-next-line no-console
                console.error("QUERY FAILED ".concat(response.status, ": ").concat(response.statusText));
                _context.t0 = api;
                _context.t1 = "QUERY FAILED ".concat(response.status, ": ").concat(response.statusText);
                _context.t2 = response.status;
                _context.t3 = response.statusText;
                _context.next = 16;
                return response.text();

              case 16:
                _context.t4 = _context.sent;
                _context.t5 = {
                  message: _context.t1,
                  status: _context.t2,
                  statusText: _context.t3,
                  body: _context.t4
                };
                _context.t6 = {
                  correlationId: correlationId
                };
                _context.t7 = {
                  type: 'ERROR',
                  payload: _context.t5,
                  metadata: _context.t6
                };

                _context.t0.dispatch.call(_context.t0, _context.t7);

                return _context.abrupt("return", nextResult);

              case 22:
                _context.next = 24;
                return response.json();

              case 24:
                result = _context.sent;
                payload = {}; // eslint-disable-next-line @typescript-eslint/no-explicit-any

                depth = payload;
                path = action.payload.path;
                path.forEach(function (current, index) {
                  depth[current] = index === path.length - 1 ? result : {};
                  depth = depth[current];
                });
                api.dispatch({
                  type: 'QUERY_COMPLETE',
                  payload: payload,
                  metadata: {
                    path: path,
                    correlationId: correlationId
                  }
                });
                _context.next = 36;
                break;

              case 32:
                _context.prev = 32;
                _context.t8 = _context["catch"](4);
                // eslint-disable-next-line no-console
                console.error(_context.t8);
                api.dispatch({
                  type: 'ERROR',
                  payload: {
                    message: _context.t8.toString()
                  },
                  metadata: {
                    correlationId: correlationId
                  }
                });

              case 36:
                _context.prev = 36;
                api.dispatch({
                  type: 'STATE_UPDATED',
                  metadata: {
                    correlationId: correlationId
                  }
                });
                return _context.finish(36);

              case 39:
                _context.next = 71;
                break;

              case 41:
                if (!(action.type === 'COMMAND')) {
                  _context.next = 71;
                  break;
                }

                _url = (0, _buildUrl.buildUrl)(api.getState().config.baseUrl, action.payload.endpoint);
                _correlationId = (_action$metadata2 = action.metadata) === null || _action$metadata2 === void 0 ? void 0 : _action$metadata2.correlationId;
                _context.prev = 44;
                _context.next = 47;
                return fetch(_url, _objectSpread(_objectSpread({}, defaultFetchConfig), {}, {
                  method: (_action$config$method2 = action === null || action === void 0 ? void 0 : (_action$config3 = action.config) === null || _action$config3 === void 0 ? void 0 : _action$config3.method) !== null && _action$config$method2 !== void 0 ? _action$config$method2 : 'POST',
                  body: JSON.stringify(action.payload.params),
                  headers: _objectSpread(_objectSpread({}, defaultFetchConfig.headers), {}, {
                    authorization: ((_action$config4 = action.config) === null || _action$config4 === void 0 ? void 0 : _action$config4.authorization) || ''
                  })
                }));

              case 47:
                _response = _context.sent;

                if (!(_response.status < 200 || _response.status >= 400)) {
                  _context.next = 61;
                  break;
                }

                _context.t9 = api;
                _context.t10 = "COMMAND FAILED ".concat(_response.status, ": ").concat(_response.statusText);
                _context.t11 = _response.status;
                _context.t12 = _response.statusText;
                _context.next = 55;
                return _response.text();

              case 55:
                _context.t13 = _context.sent;
                _context.t14 = {
                  message: _context.t10,
                  status: _context.t11,
                  statusText: _context.t12,
                  body: _context.t13
                };
                _context.t15 = {
                  correlationId: _correlationId
                };
                _context.t16 = {
                  type: 'ERROR',
                  payload: _context.t14,
                  metadata: _context.t15
                };

                _context.t9.dispatch.call(_context.t9, _context.t16);

                return _context.abrupt("return", nextResult);

              case 61:
                api.dispatch({
                  type: 'COMMAND_COMPLETE',
                  metadata: {
                    correlationId: _correlationId
                  }
                });
                _context.next = 68;
                break;

              case 64:
                _context.prev = 64;
                _context.t17 = _context["catch"](44);
                // eslint-disable-next-line no-console
                console.error(_context.t17);
                api.dispatch({
                  type: 'ERROR',
                  payload: {
                    message: _context.t17.toString()
                  },
                  metadata: {
                    correlationId: _correlationId
                  }
                });

              case 68:
                _context.prev = 68;
                api.dispatch({
                  type: 'STATE_UPDATED',
                  metadata: {
                    correlationId: _correlationId
                  }
                });
                return _context.finish(68);

              case 71:
                return _context.abrupt("return", nextResult);

              case 72:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 32, 36, 39], [44, 64, 68, 71]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};

exports.fetchMiddleware = fetchMiddleware;